export const incrementBusyIndicator = () => {
    zibi.set_busyIndicator(zibi.busyIndicator + 1);
};

export const decrementBusyIndicator = () => {
    if (zibi.busyIndicator > 0) {
        zibi.set_busyIndicator(zibi.busyIndicator - 1);
    }
};